import { defineConfig } from "../config";
import { authHeader } from "../helpers";
import { utilsService } from "./utils";
const { handleResponse } = utilsService;

export const negotiationService = {
  getAllNegotiations,
  getAllNegotiationsForPlanning,
  getNegotiationById,
  getFilteredAdvertisers,
  getFilteredContacts,
  getAllStats,
  saveNegotiaion,
  deleteNegotiation,
  createStrategy,
  updateStrategy,
  getAllGoals,
};

const { apiUrl, apiVer } = defineConfig.NEGOTIATION_SERVICE;

function getApiPath(){
  return (apiUrl + apiVer + "/negotiation");
}

function getStrategyApiPath(){
  return (apiUrl + apiVer + "/negotiation/strategy");
}


function getAllNegotiations (page, pageSize = 10, negotiationsFilters = {}) {
    let filters = negotiationsFilters.filters;
    let sorter = negotiationsFilters.sorter;
    let dates = negotiationsFilters.dates;

    let queryParams = [];
    let sortType = "desc";
    let sortValue = "createdAt"
    
    for (const key in filters) {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
        if (Array.isArray(filters[key])) {
          queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key].join(","))}`);
        } else {
          queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`);
        }
      }
    }
  
    if(sorter && sorter.field) {
      if (sorter.field && sorter.order) {
        sortType = sorter.order === 'descend' ? 'desc' : 'asc';
      }
    }

    if(dates) {
      queryParams.push(`startRangeDate=${encodeURIComponent(dates[0])}`);
      queryParams.push(`endRangeDate=${encodeURIComponent(dates[1])}`);
    }

    const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
    const url = getApiPath() + "/all/" + page + "/" + pageSize + "/" + sortValue + "/" + sortType + queryString;
  
    const requestOptions = {
      method: "GET",
      headers: authHeader("application/json"),
    };
  
    return fetch(url, requestOptions)
      .then(handleResponse)
      .then((res) => {
        return res;
      });
} 

function getNegotiationById (id) {
  const url = getApiPath() + "/read/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getFilteredAdvertisers (negotiationsFilters = {}) {
  let filters = negotiationsFilters.filters;
  let sorter = negotiationsFilters.sorter;
  let dates = negotiationsFilters.dates;

  let queryParams = [];
  let sortType = "desc";
  
  for (const key in filters) {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
      if (Array.isArray(filters[key])) {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key].join(","))}`);
      } else {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`);
      }
    }
  }

  if(sorter && sorter.field) {
    if (sorter.field && sorter.order) {
      queryParams.push(`sortValue=${encodeURIComponent(sorter.field)}`);
      sortType = sorter.order === 'descend' ? 'desc' : 'asc';
    }
  } else {
    queryParams.push(`sortValue=${encodeURIComponent("createdAt")}`);
  }

  if(dates) {
    queryParams.push(`startRangeDate=${encodeURIComponent(dates[0])}`);
    queryParams.push(`endRangeDate=${encodeURIComponent(dates[1])}`);
  }

  const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
  const url = getApiPath() + "/all/filter/advertiser" + queryString;
  
    const requestOptions = {
      method: "GET",
      headers: authHeader("application/json"),
    };
  
    return fetch(url, requestOptions)
      .then(handleResponse)
      .then((res) => {
        return res;
      });
}

function getFilteredContacts (negotiationsFilters = {}) {
  let filters = negotiationsFilters.filters;
  let sorter = negotiationsFilters.sorter;
  let dates = negotiationsFilters.dates;

  let queryParams = [];
  let sortType = "desc";
  
  for (const key in filters) {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
      if (Array.isArray(filters[key])) {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key].join(","))}`);
      } else {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`);
      }
    }
  }

  if(sorter && sorter.field) {
    if (sorter.field && sorter.order) {
      queryParams.push(`sortValue=${encodeURIComponent(sorter.field)}`);
      sortType = sorter.order === 'descend' ? 'desc' : 'asc';
    }
  } else {
    queryParams.push(`sortValue=${encodeURIComponent("createdAt")}`);
  }

  if(dates) {
    queryParams.push(`startRangeDate=${encodeURIComponent(dates[0])}`);
    queryParams.push(`endRangeDate=${encodeURIComponent(dates[1])}`);
  }

  const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
  const url = getApiPath() + "/all/filter/contact" + queryString;
  
    const requestOptions = {
      method: "GET",
      headers: authHeader("application/json"),
    };
  
    return fetch(url, requestOptions)
      .then(handleResponse)
      .then((res) => {
        return res;
      });
}

function getAllStats (negotiationsFilters = {}) {
  let filters = negotiationsFilters.filters;
  let sorter = negotiationsFilters.sorter;
  let dates = negotiationsFilters.dates;

  let queryParams = [];
  let sortType = "desc";
  
  for (const key in filters) {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
      if (Array.isArray(filters[key])) {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key].join(","))}`);
      } else {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`);
      }
    }
  }

  if(sorter && sorter.field) {
    if (sorter.field && sorter.order) {
      queryParams.push(`sortValue=${encodeURIComponent(sorter.field)}`);
      sortType = sorter.order === 'descend' ? 'desc' : 'asc';
    }
  } else {
    queryParams.push(`sortValue=${encodeURIComponent("createdAt")}`);
  }

  if(dates) {
    queryParams.push(`startRangeDate=${encodeURIComponent(dates[0])}`);
    queryParams.push(`endRangeDate=${encodeURIComponent(dates[1])}`);
  }

  const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
  const url = getApiPath() + "/all/statistic" + queryString;
  
    const requestOptions = {
      method: "GET",
      headers: authHeader("application/json"),
    };
  
    return fetch(url, requestOptions)
      .then(handleResponse)
      .then((res) => {
        return res;
      });
}

function saveNegotiaion(values) {
  const url = getApiPath() + "/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(values)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteNegotiation (id) {
  const url = getApiPath() + "/delete/" + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllGoals () {
  const url = getStrategyApiPath() + "/all/goal";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createStrategy(values) {
  const url = getStrategyApiPath() + "/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(values)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateStrategy(values) {
  const url = getStrategyApiPath() + "/update";

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(values)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllNegotiationsForPlanning() {
  const url = getApiPath() + "/all/planning";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}